import { Culture } from '../../types';

export const paiute: Culture = {
  name: 'Paiute',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Ampa',
      phonetic: 'ahm-pah',
      description: 'Paiute word for "water."'
    },
    {
      word: 'Appuh',
      phonetic: 'ah-poo',
      description: 'Paiute word meaning "tree" or "wood."'
    },
    {
      word: 'Kaibab',
      phonetic: 'kai-bab',
      description: 'A Paiute term meaning "mountain lying down."'
    },
    {
      word: 'Kooyooe',
      phonetic: 'koo-yoo-eh',
      description: 'Paiute word for "fish."'
    },
    {
      word: 'Numu',
      phonetic: 'noo-moo',
      description: 'Paiute word meaning "The People."'
    },
    {
      word: 'Paya',
      phonetic: 'pah-yah',
      description: 'Paiute word meaning "fish."'
    },
    {
      word: 'Sage',
      phonetic: 'say-j',
      description: 'A word referring to sagebrush, significant in Paiute culture.'
    },
    {
      word: 'Tuhduh',
      phonetic: 'tuh-duh',
      description: 'Word for "sun" in Paiute.'
    },
    {
      word: 'Tumpit',
      phonetic: 'toom-pit',
      description: 'Paiute word for "rock."'
    }
  ]
};